// Mock data pour le site du cabinet dentaire

export const cabinetInfo = {
  name: "Pluridental 62",
  address: "75 Av. Régis Pollet, 62970 Courcelles-lès-Lens",
  phone: ["03 21 79 30 20", "03 21 79 30 21"],
  email: "pluridental62@outlook.com",
  doctolib: "https://rdvdentiste.net/courcelles-les-lens/taibi-zouaoui-bounoua.html#nouveau-patient",
  hours: [
    { day: "Lundi", time: "09:00 - 12:30 / 14:00 - 19:00" },
    { day: "Mardi", time: "09:00 - 12:30 / 14:00 - 19:00" },
    { day: "Mercredi", time: "09:00 - 12:30 / 14:00 - 18:00" },
    { day: "Jeudi", time: "09:00 - 12:30 / 14:00 - 19:00" },
    { day: "Vendredi", time: "09:00 - 12:30 / 14:00 - 18:00" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Soins Dentaires",
    category: "Omnipratique",
    description: "Consultations, détartrage, traitement des caries, soins preventifs et bilan bucco-dentaire complet pour toute la famille.",
    icon: "tooth",
    color: "purple"
  },
  {
    id: 2,
    title: "Implants Dentaires",
    category: "Implantologie",
    description: "Pose d'implants unitaires ou multiples, solutions prothétiques sur implants, bridges et couronnes pour retrouver un sourire naturel.",
    icon: "crown",
    color: "blue"
  },
  {
    id: 3,
    title: "Soins Parodontaux",
    category: "Parodontologie",
    description: "Traitement des maladies des gencives, détartrage sous-gingival, chirurgie parodontale et suivi des parodontites.",
    icon: "shield",
    color: "green"
  },
  {
    id: 4,
    title: "Orthodontie Traditionnelle",
    category: "Orthodontie",
    description: "Appareils dentaires fixes et amovibles pour enfants et adultes, correction des malocclusions et alignement dentaire.",
    icon: "alignLeft",
    color: "pink"
  },
  {
    id: 5,
    title: "Gouttières Transparentes",
    category: "Orthodontie",
    description: "Fabrication in-office pour un gain de temps exceptionnel, une qualité optimale et un suivi personnalisé régulier tout au long de votre traitement.",
    icon: "sparkles",
    color: "orange"
  },
  {
    id: 6,
    title: "Prothèses & Chirurgie",
    category: "Omnipratique",
    description: "Couronnes, bridges, prothèses complètes, extractions et interventions chirurgicales réalisées dans le cabinet.",
    icon: "scissors",
    color: "grey"
  }
];

export const technologies = [
  {
    id: 1,
    name: "Radiographie 3D",
    description: "Imagerie de pointe pour des diagnostics précis et une planification optimale des traitements implantaires et parodontaux."
  },
  {
    id: 2,
    name: "Empreintes Numériques",
    description: "Scanner intra-oral pour des empreintes confortables et ultra-précises, sans pâte. Idéal pour les gouttières orthodontiques."
  },
  {
    id: 3,
    name: "Laser Dentaire",
    description: "Technologie laser pour des soins moins invasifs, plus précis et plus confortables, notamment en parodontologie."
  },
  {
    id: 4,
    name: "Stérilisation Avancée",
    description: "Équipements de stérilisation de dernière génération pour votre sécurité maximale à chaque consultation."
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. ZOUAOUI BOUNOUA Hadjira",
    role: "Chirurgien-Dentiste",
    status: "Titulaire",
    specialties: ["Omnipratique", "Orthodontie", "Gouttières transparentes"],
    initials: "ZB"
  },
  {
    id: 2,
    name: "Dr. TAIBI Feriel",
    role: "Chirurgien-Dentiste",
    status: "Titulaire",
    specialties: ["Omnipratique", "Implantologie", "Parodontologie"],
    initials: "TF"
  },
  {
    id: 3,
    name: "Dr. SAID Walid",
    role: "Chirurgien-Dentiste",
    status: "Collaborateur",
    specialties: ["Omnipratique", "Soins conservateurs"],
    initials: "SW"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie L.",
    rating: 5,
    comment: "Cabinet moderne et accueillant. L'équipe est très professionnelle et rassurante. Les soins sont effectués avec douceur.",
    date: "Janvier 2025"
  },
  {
    id: 2,
    name: "Thomas B.",
    rating: 5,
    comment: "Excellente expérience pour mon traitement par gouttières transparentes. Résultats visibles rapidement et suivi impeccable.",
    date: "Décembre 2024"
  },
  {
    id: 3,
    name: "Julie D.",
    rating: 5,
    comment: "Personnel à l'écoute et équipements ultra-modernes. Je recommande vivement ce cabinet pour toute la famille.",
    date: "Novembre 2024"
  },
  {
    id: 4,
    name: "Alexandre P.",
    rating: 5,
    comment: "Prise en charge rapide et professionnelle. Les explications sont claires et le cabinet est très bien équipé.",
    date: "Octobre 2024"
  }
];
